/**
 * @Description:
 * @author licheng
 * @date 2020/4/10 5:28 PM
 */

/******************************************************************************************
 * ************************************** 系统信息 *****************************************
 ******************************************************************************************/
const APP_INFO = {
  version: '1.0.0', // 版本号
  name: '南京虎牙示范PC项目', // 项目名称
  create: '20210525', // 创建日期
}
window.APP_INFO = APP_INFO;

/******************************************************************************************
 * ************************************** 枚举值 *****************************************
 ******************************************************************************************/
/**
  枚举示例
 */
// 字典项
const SYS_DICT_ENUM = {
  DEPT_DIST: 'deptDist', //行政区划
  POLE_BOX_TYPE: 'poleBoxTypeDist', //电箱类型
}
window.SYS_DICT_ENUM = SYS_DICT_ENUM;

/******************************************************************************************
 * ************************************** 缓存key *****************************************
 ******************************************************************************************/
const k_login_info_cache = APP_INFO.create + "k_login_info_cache";
const k_user_info_cache = APP_INFO.create + "k_user_info_cache";
const k_sys_config_cache = APP_INFO.create + "k_sys_config_cache"; // 系统配置项

window.k_login_info_cache = k_login_info_cache;
window.k_user_info_cache = k_user_info_cache;
window.k_sys_config_cache = k_sys_config_cache;





// WEBPACK FOOTER //
// ./src/utils/js/constant.js